import { useQueryClient, useMutation, useQuery } from '@tanstack/react-query';
import { AssessmentLinkAPI } from 'lib/api/firebase/apis/assessment-link';
import { PatientAssessmentLink } from 'lib/documents/patient-assessment/patient-assessment-link';
import { queryKeyFactory } from 'lib/utils/queryKeyFactory';

export function useAssessmentLinkAPI() {
  const queryClient = useQueryClient();
  const create = useMutation({
    mutationFn: AssessmentLinkAPI.create,
    onSuccess(_data, variables) {
      queryClient.invalidateQueries({
        queryKey: queryKeyFactory.patient.assessmentLink.root(
          variables.patientId
        )
      });
    }
  });

  const generateToken = useMutation({
    mutationFn: AssessmentLinkAPI.generateToken
  });

  const deactivate = useMutation({
    mutationFn: (args: {
      assessmentLinkId: string;
      /**
       * NOTE: This field is only needed in order to invalidate the query cache for the patient
       */
      patientId: string;
    }) =>
      AssessmentLinkAPI.deactivate({ assessmentLinkId: args.assessmentLinkId }),
    onSuccess(_data, variables) {
      queryClient.invalidateQueries({
        queryKey: queryKeyFactory.patient.assessmentLink.root(
          variables.patientId
        )
      });
    }
  });

  const consumeToken = useMutation({
    mutationFn: AssessmentLinkAPI.consumeToken
  });
  return {
    create,
    deactivate,
    generateToken,
    consumeToken
  };
}

export function useAssessmentLinkGenerateToken(
  assessmentLinkId: PatientAssessmentLink['id']
) {
  return useQuery({
    queryKey: queryKeyFactory.patient.assessmentLink.token(assessmentLinkId),
    queryFn: () => AssessmentLinkAPI.generateToken({ assessmentLinkId })
  });
}
export function useAssessmentLinkListQuery(patientId: string) {
  return useQuery({
    queryKey: queryKeyFactory.patient.assessmentLink.list(patientId),
    queryFn: () => AssessmentLinkAPI.list({ patientId })
  });
}
